import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  RadarChart,
  Radar,
  PolarGrid,
  PolarAngleAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
  LabelList,
} from "recharts";
import { useSelector } from "react-redux";
import { getL1SheetProperty } from "../../../features/reduxworkbook/WorkbookSlice";
import { getColourSchemeByID } from "../../../Colors/ColorPalettes";
import { formatNumber } from "../Utils/FormatNumbers";
import { CustomTooltip } from "../Custom/CustomTooltipContent";
import { CustomLegend } from "../Custom/CustomLegendContent";
import { castToNumberData } from "../Utils/transformData";

const RadarChartComp = ({
  Data: incomingData,
  valueKeys,
  Sheetid,
  toolTipKeys = [],
  groupByKeys,
}) => {
  const responseKeys = useMemo(
    () => valueKeys.map((item) => item.responseKey),
    [valueKeys]
  );

  const Data = useMemo(
    () => castToNumberData(incomingData, responseKeys),
    [incomingData, responseKeys]
  );

  // const SufixPrefix = { ...valueKeys.map((item) => item.numberFormat)[0] };
  const SufixPrefix = useMemo(
    () => ({ ...valueKeys[0]?.numberFormat }),
    [valueKeys]
  );
  console.log(valueKeys, groupByKeys);



  const customizationObject = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "customization")
  );

  const {
    colorSchemeid,
    isLegendVisible,
    legendAlign,
    legendVerticalAlign,
    legendLayout,
    isLabelVisible,
    labelFontColor,
    labelFontSize,
    labelRotate,
    customeTooltip,
    colorMapping,
    // outerRadius = "60%",
  } = customizationObject;
  const colorScheme = getColourSchemeByID(colorSchemeid);
  const COLORS = colorScheme?.colors;

  console.log(colorMapping);
  const containerRef = useRef(null);
  const [outerRadius, setOuterRadius] = useState(0);
  useEffect(() => {
    if (containerRef.current) {
      const updateSizes = () => {
        const containerWidth = containerRef.current.offsetWidth;
        const containerHeight = containerRef.current.offsetHeight;
        console.log(containerHeight);
        console.log(containerWidth);

        const maxRadius = Math.min(containerWidth, containerHeight) / 2 - 10;
        setOuterRadius(
          Math.min(customizationObject.outerRadius, maxRadius * 0.7)
        );
      };

      updateSizes();
      window.addEventListener("resize", updateSizes);

      return () => window.removeEventListener("resize", updateSizes);
    }
  }, [customizationObject]);

  if (!customizationObject || !Data) {
    return null;
  }

  // const pointSize = customizationObject.pointSize;

  return (
    <div ref={containerRef} style={{ width: "100%", height: "100%" }}>
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart
          outerRadius={outerRadius}
          data={Data}
          margin={{
            top: 10,
            bottom: 10,
            left: 10,
            right: 10,
          }}
        >
          {groupByKeys.length > 0 ? <PolarGrid /> : null}
          <PolarAngleAxis dataKey={groupByKeys[0]?.responseKey} />
          {/* <PolarRadiusAxis angle={30} domain={[0, "dataMax"]} /> */}

          {/* dynamic */}

          {groupByKeys.map((item, index) => {


            // const baseColor = colorMapping?.[item] || COLORS[index % COLORS.length];
            // console.log(baseColor);


            return (
              <Radar
                key={item.id}
                dataKey={valueKeys[0]?.responseKey}
                stroke={COLORS[index % COLORS.length]}
                fill={COLORS[index % COLORS.length]}
                fillOpacity={0.6}
                dot={{ r: customizationObject.pointSize }}
              >
                {isLabelVisible && (
                  <LabelList
                    dataKey={valueKeys[0]?.responseKey}
                    position="top"
                    fill={labelFontColor}
                    stroke={labelFontColor === "white" ? "black" : "white"}
                    fontSize={labelFontSize}
                    angle={labelRotate}
                    strokeWidth={0.2}
                    formatter={(value) => formatNumber(value, SufixPrefix)}
                  />
                )}
              </Radar>
            );
          })}


          {isLegendVisible && (
            <Legend
              align={legendAlign.value}
              verticalAlign={legendVerticalAlign.value}
              layout={legendLayout.value}
              iconType="square"
              content={
                <CustomLegend
                  {...{
                    align: legendAlign.value,
                    verticalAlign: legendVerticalAlign.value,
                    layout: legendLayout.value,
                    valueKeys,
                  }}
                />
              }
            />
          )}

          {customeTooltip && (
            <Tooltip
              content={
                <CustomTooltip
                  tooltipKeys={toolTipKeys}
                  columnKeys={groupByKeys}
                  valueKeys={valueKeys}
                  SufixPrefix={SufixPrefix}
                  chartType={"radar"}
                  colorSchemeid={colorSchemeid}
                />
              }
            />
          )}
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RadarChartComp;
